"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.endpoints = void 0;
exports.endpoints = {
    au: "wss://ai2s8hepn371m-ats.iot.ap-southeast-2.amazonaws.com:443/mqtt",
    ca: "wss://ai2s8hepn371m-ats.iot.ca-central-1.amazonaws.com:443/mqtt",
    eu: "wss://ai2s8hepn371m-ats.iot.eu-west-1.amazonaws.com:443/mqtt",
    us: "wss://ai2s8hepn371m-ats.iot.us-east-1.amazonaws.com:443/mqtt",
    staging: "wss://a2necd4je5skfw-ats.iot.us-east-1.amazonaws.com:443/mqtt",
};
//# sourceMappingURL=endpoints.js.map